export default __webpack_public_path__ + "static/media/blog-img229.bbb813e7.jpg";